import { CustomLayout } from "./wrapPageElement";
import "@fontsource/creepster"

import "./src/styles/layout.css";

export const wrapPageElement = CustomLayout;
